import { eventTokensSelector } from "@/redux/loadedContent/loadedContentSlice";
import { useSelector } from "react-redux";

const cdnBase = import.meta.env.VITE_APP_ASSETS_BASE_URL;

/**
 * An evolution cost's event tokens with their icon, for hosts that draw them
 * next to coins and points. An unknown token gets the generic token icon.
 */
export const useTokenCosts = (
  tokens: { eventTokenId: number; amount: number }[],
) => {
  const eventTokens = useSelector(eventTokensSelector);
  return tokens.map(({ eventTokenId, amount }) => {
    const token = eventTokens.find((t) => t.eventTokenId === eventTokenId);
    return {
      eventTokenId,
      amount,
      name: token?.displayName ?? "",
      iconUrl: token
        ? `${cdnBase}/${token.iconKey}`
        : `${cdnBase}/misc/token.png`,
    };
  });
};
